import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { Events } from '@providers/common/events.service';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";

@Component({
    selector: 'modal-resume-detail',
    templateUrl: './modal-resume-detail.component.html',
    styleUrls: ['./modal-resume-detail.component.scss'],
    standalone: false,
})
export class ResumeDetailChatAIModal implements OnInit {
    @Input('modalTitle') modalTitle: string = '';
    @Input('resumeDetail') resumeDetail: string = '';

    constructor(
        private modalCtrl: ModalController,
        private events: Events,
    ) {
        this.events.publish('menulat:togglevisibility');
        addIcons({ close });
    }

    ngOnInit() { }

    /**
     * @name dismiss
     * @desc Metodo que te regresa en la navegación
     **/
    dismiss() {
        this.events.publish('menulat:togglevisibility');
        this.modalCtrl.dismiss();
    }
}
